import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getDraftOrders as getDraftOrdersApi,
    completeOrder as completeOrderApi,
    deleteOrder as deleteOrderApi,
} from "../../helpers/backend_helper";

export const fetchDraftOrders = createAsyncThunk("draftOrders/fetch", async () => {
    try {
        const response = await getDraftOrdersApi();
        return response;
    } catch (error: any) {
        throw error;
    }
});

export const completeDraftOrder = createAsyncThunk(
    "draftOrders/complete",
    async (orderId: string | number) => {
        try {
            await completeOrderApi(orderId);
            return orderId;
        } catch (error: any) {
            throw error;
        }
    }
);

export const deleteDraftOrder = createAsyncThunk(
    "draftOrders/delete",
    async (orderId: string | number) => {
        try {
            await deleteOrderApi(orderId);
            return orderId;
        } catch (error: any) {
            throw error;
        }
    }
);
